export default __webpack_public_path__ + "static/media/ID_MIKE_Gromax Kaiju.c6e0055d.jpg";